let xoffset = 0;
let yoffset = 0;
let tempX = 0;
let tempY = 0;
let elOffset: BoundType;
let node: HTMLElement;
let dropType: string;
let dropEl: HTMLElement;
Array.prototype.insert = function (index: number, ...items: Array<object>) {
	this.splice(index, 0, ...items);
	return true;
};
export function StartDrag(
	e: MouseEvent,
	id: number,
	element: HTMLElement,
	root: HTMLElement
): Promise<{ type: string; id: number; dropEl: number }> {
	return new Promise((resolve) => {
		node = document.createElement("div");
		const { width, height }: { width: number; height: number } =
			element.getBoundingClientRect();
		elOffset = element.getBoundingClientRect();
		node.classList.add("dragging-node");
		node.style.width = width + "px";
		node.style.height = height + "px";
		node.style.left = elOffset.left + "px";
		node.style.top = elOffset.top + "px";
		node.style.opacity = "1";
		root.appendChild(node);
		window.addEventListener("mousemove", Drag);
		const mouseupListener = () => {
			window.removeEventListener("mousemove", Drag);
			window.removeEventListener("mouseup", mouseupListener);
			root.removeChild(node);

			resolve({ type: dropType, id, dropEl: dropEl && Number(dropEl.id) });
		};
		window.addEventListener("mouseup", mouseupListener);
	});
}
export function GetMouseXY(e: MouseEvent) {
	if (xoffset == 0 && yoffset == 0) {
		xoffset = Number(e.pageX) - Number(elOffset.left);
		yoffset = Number(e.pageY) - Number(elOffset.top);
	}
	tempX = e.pageX;
	tempY = e.pageY;
	if (tempX < 0) {
		tempX = 0;
	}
	if (tempY < 0) {
		tempY = 0;
	}
	return true;
}

function Drag(e: MouseEvent) {
	console.log("drag");
	e.preventDefault();
	GetMouseXY(e);
	const ELEMENTS_MOUSE_IS_OVER: Array<HTMLElement> = document.elementsFromPoint(
		tempX,
		tempY
	) as HTMLElement[];
	for (let i = 0; i < ELEMENTS_MOUSE_IS_OVER.length; i++) {
		if (ELEMENTS_MOUSE_IS_OVER[i].classList.contains("stack-container")) {
			const OFFSET: BoundType = ELEMENTS_MOUSE_IS_OVER[i].getBoundingClientRect();
			const OW: number = OFFSET.left;
			const OH: number = OFFSET.top;
			const WW: number = ELEMENTS_MOUSE_IS_OVER[i].offsetWidth;
			const HH: number = ELEMENTS_MOUSE_IS_OVER[i].offsetHeight;
			if (tempX > OW + (WW / 3) * 2) {
				node.style.top = OH + 40 + "px";
				node.style.width = WW / 2 + "px";
				node.style.left = OW + WW / 2 + "px";
				node.style.height = HH - 40 + "px";
				dropType = "right";
			}
			if (tempX < OW + WW / 3) {
				node.style.top = OH + 40 + "px";
				node.style.width = WW / 2 + "px";
				node.style.left = OW + "px";
				node.style.height = HH - 40 + "px";
				dropType = "left";
			}
			if (tempX > OW + WW / 3 && tempX < OW + (WW / 3) * 2) {
				if (tempY > OH + HH / 2) {
					node.style.top = OH + HH / 2 + "px";
					node.style.width = WW + "px";
					node.style.left = OW + "px";
					node.style.height = HH / 2 + "px";
					dropType = "bottom";
				}
				if (tempY < OH + HH / 2) {
					node.style.top = OH + 40 + "px";
					node.style.width = WW + "px";
					node.style.left = OW + "px";
					node.style.height = HH / 2 + "px";
					dropType = "top";
				}
			}

			dropEl = ELEMENTS_MOUSE_IS_OVER[i];
		}
		if (ELEMENTS_MOUSE_IS_OVER[i].classList.contains("right-drop-zone")) {
			const OFFSET: BoundType = ELEMENTS_MOUSE_IS_OVER[i].getBoundingClientRect();
			const OW: number = OFFSET.left;
			const WW: number = ELEMENTS_MOUSE_IS_OVER[i].offsetWidth;
			const OH: number = OFFSET.top;
			const HH = ELEMENTS_MOUSE_IS_OVER[i].offsetHeight;
			dropType = "right-zone";
			node.style.top = OH + "px";
			node.style.width = 250 + "px";
			node.style.left = OW - 250 + WW + "px";
			node.style.height = HH + "px";
			dropEl = ELEMENTS_MOUSE_IS_OVER[i].parentNode as HTMLElement;
			break;
		}
		if (ELEMENTS_MOUSE_IS_OVER[i].classList.contains("left-drop-zone")) {
			const OFFSET: BoundType = ELEMENTS_MOUSE_IS_OVER[i].getBoundingClientRect();
			const OW: number = OFFSET.left;
			const OH: number = OFFSET.top;
			// const WW:number = ELEMENTS_MOUSE_IS_OVER[i].offsetWidth;
			const HH = ELEMENTS_MOUSE_IS_OVER[i].offsetHeight;
			dropType = "left-zone";
			node.style.top = OH + "px";
			node.style.width = 250 + "px";
			node.style.left = OW + "px";
			node.style.height = HH + "px";
			dropEl = ELEMENTS_MOUSE_IS_OVER[i].parentNode as HTMLElement;
			break;
		}
		if (ELEMENTS_MOUSE_IS_OVER[i].classList.contains("bottom-drop-zone")) {
			const OFFSET: BoundType = ELEMENTS_MOUSE_IS_OVER[i].getBoundingClientRect();
			const OW: number = OFFSET.left;
			const OH: number = OFFSET.top;
			const WW: number = ELEMENTS_MOUSE_IS_OVER[i].offsetWidth;
			const HH = ELEMENTS_MOUSE_IS_OVER[i].offsetHeight;
			dropType = "bottom-zone";
			node.style.top = OH + "px";
			node.style.width = WW + "px";
			node.style.left = OW + "px";
			node.style.height = HH + "px";

			dropEl = ELEMENTS_MOUSE_IS_OVER[i].parentNode?.parentNode?.parentNode as HTMLElement;
			break;
		}
		if (ELEMENTS_MOUSE_IS_OVER[i].classList.contains("stack-tabs")) {
			const OFFSET: BoundType = ELEMENTS_MOUSE_IS_OVER[i].getBoundingClientRect();
			const OW: number = OFFSET.left;
			const OH: number = OFFSET.top;
			const WW: number = ELEMENTS_MOUSE_IS_OVER[i].offsetWidth;
			const HH = 40;
			dropType = "stack";
			node.style.top = OH + "px";
			node.style.width = WW + "px";
			node.style.left = OW + "px";
			node.style.height = HH + "px";
			dropEl = ELEMENTS_MOUSE_IS_OVER[i].parentNode as HTMLElement;
			break;
		}
	}
}
export function GetNewId(): number {
	return Math.floor(Math.random() * 90000) + 10000;
}
export function RetrieveElementFromLayout(layout: LayoutType, id: number): LayoutType | void {
	let val: LayoutType | void;
	if (layout.id == id) {
		val = layout;
	}
	if ("children" in layout) {
		for (const p in layout.children) {
			const V: LayoutType | void = RetrieveElementFromLayout(layout.children[p], id);
			if (V != null) {
				val = V;
			}
		}
	}
	return val;
}

export function RetrieveParentElementFromLayout(layout: LayoutType, id: number): LayoutType | void {
	let c: LayoutType | void;
	if (layout.children) {
		const M: Array<number> = layout.children.map((item) => item.id);
		if (M.includes(id)) {
			c = layout;
		} else {
			for (const i in layout.children) {
				const C2 = RetrieveParentElementFromLayout(layout.children[i], id);
				if (C2 != null) {
					c = C2;
				}
			}
		}
	}
	return c;
}

export function RemoveElementFromChildren(
	children: Array<LayoutType>,
	id: number
): Array<LayoutType> {
	return children
		.map((item) => {
			return { ...item };
		})
		.filter((item) => {
			if ("children" in item) {
				item.children = RemoveElementFromChildren(item.children, id);
				if (item.children.length == 0) {
					return false;
				}
			}
			if (item.id == id) {
				const flex = item.componentState.flex;
				for (let i = 0; i < children.length; i++) {
					children[i].componentState.flex += flex / (children.length - 1);
				}
			}
			return item.id !== id;
		});
}

export function AddElementToStack(children: Array<LayoutType>, id: number, el: LayoutType) {
	const C: Array<LayoutType> = children;
	for (const i in children) {
		if (children[i].id == id) {
			children[i].componentState.flex = 1;
			children[i].children.push(el);
		} else {
			if ("children" in children[i]) {
				AddElementToStack(children[i].children, id, el);
			}
		}
	}
	return C;
}

export function FindNode(id: number, array: Array<LayoutType>): LayoutType | void {
	for (const node of array) {
		if (node.id === id) return node;
		if (node.children) {
			const child: LayoutType | void = FindNode(id, node.children);
			if (child) return child;
		}
	}
}
export function UpdateFlex(array: Array<LayoutType>, id: number, flex: number): LayoutType | void {
	for (const node of array) {
		if (node.id == id) {
			node.componentState.lastFlex = node.componentState.flex;
			node.componentState.flex = flex;
			return node;
		}
		if (node.children) {
			const child: LayoutType | void = UpdateFlex(node.children, id, flex);
			if (child) return child;
		}
	}
}
export function CollapsePanel(layout: LayoutType, type: string, id: number, id2: number) {
	const P1: LayoutType | void = FindNode(id, layout.children);
	const P2: LayoutType | void = FindNode(id2, layout.children);
	if (P1 == null || P2 == null) return;
	const P1_FLEX: number = P1.componentState.flex;
	const P2_FLEX: number = P2.componentState.flex;
	const TOTAL_FLEX: number = P1_FLEX + P2_FLEX;
	const WH: number = window.innerHeight;
	const WW: number = window.innerWidth;
	const PX_INCREMENT: number = TOTAL_FLEX / (type == "column" ? WH : WW);
	const COLLAPSE_SIZE: number = PX_INCREMENT * 1;
	const COLLAPSE_DIFF_SIZE: number = TOTAL_FLEX - COLLAPSE_SIZE;
	if (P1_FLEX < 0.01) {
		UpdateFlex(layout.children, P1.id, P1.componentState.lastFlex);
		UpdateFlex(layout.children, P2.id, P2.componentState.lastFlex);
	} else if (P2_FLEX < 0.01) {
		UpdateFlex(layout.children, P1.id, P1.componentState.lastFlex);
		UpdateFlex(layout.children, P2.id, P2.componentState.lastFlex);
	} else {
		UpdateFlex(layout.children, P1.id, COLLAPSE_SIZE);
		UpdateFlex(layout.children, P2.id, COLLAPSE_DIFF_SIZE);
	}
}
export function CleanLayout(layout: LayoutType): void {
	// if(layout.componentName == 'Visualizer' || layout.componentName == 'MIDDLE') return;

	if ("children" in layout) {
		const existingKeys: number[] = [];

		for (let i = 0; i < layout.children.length; i++) {
			if (!existingKeys.includes(layout.children[i].id)) {
				existingKeys.push(layout.children[i].id);
			} else {
				layout.children.splice(i, 1);
				continue;
			}

			if (layout.children[i].type == "column" && layout.children[i].children.length == 1) {
				//  const tempFlex =  JSON.parse(JSON.stringify(layout.children[i].componentState.flex));
				if (
					layout.children[i].children[0].type == "row" ||
					layout.children[i].children[0].type == "column" ||
					layout.children[i].children[0].type == "stacked"
				) {
					layout.children[i] = layout.children[i].children[0];
					// layout.children[i].componentState.flex = tempFlex;
				} else {
					if (layout.children[i].children != null) {
						//  layout.children[i].componentState.flex = layout.children[i].componentState.flex;
						//  layout.children[i].type = layout.children[i].componentName == 'MIDDLE' ? layout.children[i].type : 'stacked',
						layout.children[i].id = GetNewId();
					}
				}
			} else if (
				layout.children[i].type == "row" &&
				layout.children[i].children.length == 1
			) {
				// const tempFlex =  JSON.parse(JSON.stringify(layout.children[i].componentState.flex));
				if (
					layout.children[i].children[0].type == "row" ||
					layout.children[i].children[0].type == "column" ||
					layout.children[i].children[0].type == "stacked"
				) {
					layout.children[i] = layout.children[i].children[0];
					// layout.children[i].componentState.flex = tempFlex;
				} else {
					if (layout.children[i].children != null) {
						// layout.children[i].componentState.flex = layout.children[i].componentState.flex;
						// layout.children[i].type = layout.children[i].componentName == 'MIDDLE' ? layout.children[i].type : 'stacked',
						layout.children[i].id = GetNewId();
					}
				}
			}
			CleanLayout(layout.children[i]);
		}
	}
}
export function AddElementToRow(
	layout: LayoutType,
	id: number,
	destId: number,
	el: LayoutType,
	type: string,
	stateLayout: LayoutType
): void {
	if (layout.id == id) {
		if (layout.children) {
			const IDX: number = layout.children.map((item) => item.id).indexOf(destId);
			if (type == "left") {
				layout.children.forEach((item) => {
					item.componentState.flex = 1;
				});
				if (layout.children.length == 1 && layout.type == "column") {
					layout.type = "row";
					layout.componentState.flex = 1;
					RemoveElementFromChildren(stateLayout.children, Number(layout.id));
					const P_ID: LayoutType | void = RetrieveParentElementFromLayout(
						stateLayout,
						Number(layout.id)
					);
					if (P_ID == null) return;
					AddElementToRow(stateLayout, el.id, P_ID.id, el, type, stateLayout);
				} else {
					layout.children.insert(IDX, el);
				}
			} else {
				if (layout.children.length == 1 && layout.type == "column") {
					layout.type = "row";
					layout.componentState.flex = 1;
				}
				layout.children.insert(IDX + 1, el);
			}
		} else {
			console.log("ELEMENT HAS NO CHILDREN. NEED TO CREATE PARENT WITH CHILDS");
		}
	} else {
		for (const i in layout.children) {
			AddElementToRow(layout.children[i], id, destId, el, type, stateLayout);
		}
	}
}
